import React, { useEffect, useState } from "react";
import CardHomeroom from '../components/CardHomeroom'
import HeaderText from '../components/HeaderText'
import PageStep from '../components/PageStep'
import { Row, Col, Pagination } from 'react-bootstrap'
import UserService from "../controllers/UserService"
import $ from 'jquery'
import {Helmet} from "react-helmet";

let sort = '';
const HomeRoomPage = props => {
    const [selection, setSelection] = useState('');
    const [pagination, setPagination] = useState('');
    const [data, setData] = useState('');
    // const [sort, setSort] = useState('');



    useEffect(() => {
        UserService.getCategory().then((res) => {
            // console.log('getCategory');
            // console.log(res);
            let temp = `<select id="selectCategory" class="d-inline">`;
            temp += '<option value="">เลือกหมวดหมู่</option>';
            res.data.data.forEach(function (entry) {

                temp += `<option value="${entry.name}">${entry.displayName}</option>`;
                // temp += `<option value="${entry.id}">${entry.displayName}</option>`;
            });
            temp += `</select>`;

            temp = <div className="d-inline" dangerouslySetInnerHTML={{ __html: temp }} />
            setSelection(temp);
            setData(<CardHomeroom hideDate="0" />);
            UserService.getTopics({ page: 0, category: '' }).then((res) => {
                getPagination(res.data.data.total, 1);
                //getPagination(200, 1);
            });
        }).then((res) => {

            $('#selectCategory').on('change', function () {
                console.log('trigger change selectCategory');
                var categoryCode = this.value;
                setData(<CardHomeroom hideDate="0" category={categoryCode} page={1} />);
                var temp = {
                    page: 0,
                    category: categoryCode
                }
                UserService.getTopics(temp).then((res) => {
                    getPagination(res.data.total, 1);
                    //getPagination(200, 1);
                });
            });

            $('#sort').on('change', function () {
                var sortValue = this.value;
                console.log('trigger change sort');
                handleSortClick(sortValue);
            });


        });



    }, []);


    const getPagination = (totalPage = 0, currentPage = 1) => {
        var mod = totalPage % 50;
        var totalPage = parseInt(totalPage / 50)
        if (mod > 0) {
            totalPage = totalPage + 1;
        }

        var range = 3;

        if (totalPage < range) {
            range = totalPage;
        }

        const paging = { range: range, pages: totalPage };
        var pageArray = doPaging(currentPage, paging);

        var classP = '';
        var classN = '';
        // console.log(pageArray);
        // console.log(pageArray.length);
        if (pageArray.length === 0) {
            return '';
        }
        if (currentPage === 1) {
            classP = "disabled"
        }

        if (currentPage === totalPage) {
            classN = "disabled"
        }

        if (totalPage === 1) {
            var html = '';
        } else if (totalPage === 2) {
            var html = <Pagination>
                <Pagination.First className='disabled' />
                <Pagination.Item className={pageArray[0]['status']} onClick={() => handlePaginationClick(pageArray[0]['id'])} >{pageArray[0]['id']}</Pagination.Item>
                <Pagination.Item className={pageArray[1]['status']} onClick={() => handlePaginationClick(pageArray[1]['id'])} >{pageArray[1]['id']}</Pagination.Item>
                <Pagination.Last className='disabled' />
            </Pagination>
        } else if (totalPage === 3) {
            var html = <Pagination>
                <Pagination.First className='disabled' />
                <Pagination.Item className={pageArray[0]['status']} onClick={() => handlePaginationClick(pageArray[0]['id'])} >{pageArray[0]['id']}</Pagination.Item>
                <Pagination.Item className={pageArray[1]['status']} onClick={() => handlePaginationClick(pageArray[1]['id'])} >{pageArray[1]['id']}</Pagination.Item>
                <Pagination.Item className={pageArray[2]['status']} onClick={() => handlePaginationClick(pageArray[2]['id'])} >{pageArray[2]['id']}</Pagination.Item>
                <Pagination.Last className='disabled' />
            </Pagination>
        } else {
            var html = <Pagination>
                <Pagination.First className={classP} onClick={() => handlePaginationClick(1)} />
                <Pagination.Item className={pageArray[0]['status']} onClick={() => handlePaginationClick(pageArray[0]['id'])} >{pageArray[0]['id']}</Pagination.Item>
                <Pagination.Item className={pageArray[1]['status']} onClick={() => handlePaginationClick(pageArray[1]['id'])} >{pageArray[1]['id']}</Pagination.Item>
                <Pagination.Item className={pageArray[2]['status']} onClick={() => handlePaginationClick(pageArray[2]['id'])} >{pageArray[2]['id']}</Pagination.Item>
                <Pagination.Last className={classN} onClick={() => handlePaginationClick(totalPage)} />
            </Pagination>
        }

        setPagination(html);
    }

    const handlePaginationClick = (page) => {
        console.log(sort);
        var tempCat = $('#selectCategory').val();
        setData(<CardHomeroom hideDate="0" category={tempCat} page={page} sort={sort} />);
        UserService.getTopics({ page: page - 1, category: tempCat, sort: sort }).then((res) => {
            getPagination(res.data.data.total, page);
            //getPagination(200, page);
        });

    }


    const handleSortClick = (key) => {

        sort = key;
        $('.sortItem').removeClass('primary-text');
        $('.sortItem').addClass('gray-text4');
        if (key === 'random') {
            $('#selectCategory').val('');
            setData(<CardHomeroom hideDate="0" random='1' />);
            UserService.getTopics({ random: '1' }).then((res) => {
                setPagination('');
            });

        } else {
            var tempCat = $('#selectCategory').val();
            setData(<CardHomeroom hideDate="0" category={tempCat} page={1} sort={key} />);
            UserService.getTopics({ page: 1, category: tempCat, sort: key }).then((res) => {
                getPagination(res.data.data.total, 1);
                //getPagination(200, 1);
            });

        }
        var targetName = '#' + key;
        console.log(targetName);
        $(targetName).addClass('primary-text');
        $(targetName).removeClass('gray-text4');
        $('#sort').val(key);

    }

    return (
        <div>
            <Helmet>
                <title>กิจกรรมค้นหาคุณค่าผ่านนิสัยเชิงบวก จากเรื่องราวที่สร้างแรงบันดาลใจ ของคนทั่วโลก - Mindsetmaker.co</title>
                <meta property="og:title"       content="กิจกรรมค้นหาคุณค่าผ่านนิสัยเชิงบวก จากเรื่องราวที่สร้างแรงบันดาลใจ ของคนทั่วโลก - Mindsetmaker.co" />
                <meta property="og:description" content="เริ่มกิจกรรมปรับใจสำหรับชั่วโมงโฮมรูม จิตวิทยาเชิงบวกเริ่มต้นได้ในห้องเรียน โดยนำ 24 อุปนิสัยเชิงบวกมาใช้ผ่านเรื่องราวแรงบันดาลใจทั่วโลก" />
            </Helmet>
            <Row >
                <Col className="header-text">
                    <HeaderText cardImage="http://placehold.jp/286x180.png" text1="Homeroom" cardTitle="" text2="ห้อง ม.2/1  คุณครูสมหมาย ชายล้วน" />
                </Col>
            </Row>
            <Row className="bg-white">
                <Col xs={12} className="main-detail mb-3 mt-md-3">
                    <PageStep step="1" />
                </Col>
            </Row>
            <Row className="bg-white">
                <Col xs={12} className="main-detail text-center"><h2 className="primary-text pb-3 py-md-3 font-sarabun-bold">เรื่องราวบันดาลใจของคนทั่วโลก</h2></Col>
            </Row>
            <Row className="bg-white">
                <Col xs={12} className="main-detail mb-3">
                    <Row>
                        <Col xs={6} className="d-inline">
                            <span className="d-none d-md-inline pr-3 font-sarabun-bold">หมวดหมู่</span>
                            {selection}

                        </Col>
                        <Col xs={6} className="text-right">
                            <div className="d-inline d-md-none">
                                <select id="sort" className="ml-2 selection-custom primary-text" style={{ "alignSelf": "center" }}>
                                    <option value="createdAt"> อัพเดทล่าสุด</option>
                                    <option value="random">สุ่มคำถาม</option>
                                    <option value="usageCount">ความนิยม</option>
                                </select>
                            </div>
                            <div className="d-none d-md-inline">
                                <h5 className="sortItem primary-text click-pointer font-sarabun-bold d-inline" onClick={() => handleSortClick('createdAt')} id="createdAt">
                                    <img src='/images/icons/update_icon.png' className="activeSort mb-1" /><img src='/images/icons/grey_update_icon.png' className="nonActive mb-1" /> อัพเดทล่าสุด
                                </h5> &nbsp;|&nbsp;&nbsp;
                                <h5 onClick={() => handleSortClick('random')} className="sortItem click-pointer gray-text4 font-sarabun-bold d-inline" id="random">
                                    <img src='/images/icons/random_icon.png' className="activeSort mb-1" /><img src='/images/icons/grey _random_icon.png' className="nonActive mb-1" /> สุ่มคำถาม
                                    </h5> &nbsp;|&nbsp;&nbsp;
                                <h5 onClick={() => handleSortClick('usageCount')} className="sortItem click-pointer gray-text4 font-sarabun-bold d-inline" id="usageCount">
                                    <img src='/images/icons/poppular_icon.png' className="activeSort mb-1" /><img src='/images/icons/grey_poppular icon.png' className="nonActive mb-1" /> ความนิยม
                                </h5>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className="bg-lightness-blue">
                <Col className="mx-3 text-center main-detail m-auto">
                    {data}
                </Col>
            </Row>

            <div className="row pageinage bg-lightness-blue">
                <div className="p-5 d-flex justify-content-center w-100">
                    {pagination}
                </div>

            </div>
        </div>
    );
};


function doPaging(current, { range, pages, start = 1 }) {

    const paging = [];
    var i = Math.min(pages + start - range, Math.max(start, current - (range / 2 | 0)));
    const end = i + range;
    // while (i < end) { paging.push(i === current ? `[${i++}]` : `${i++}`) }
    while (i < end) {
        paging.push({ "status": i === current ? `active` : ``, "id": `${i++}` })
    }
    return paging;
}
export default HomeRoomPage;